import Box from "@mui/material/Box";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import {makeStyles} from "@mui/styles";
import {AdapterMoment} from "@mui/x-date-pickers/AdapterMoment";
import {DatePicker} from "@mui/x-date-pickers/DatePicker";
import {LocalizationProvider} from "@mui/x-date-pickers/LocalizationProvider";
import moment from "moment";
import {useEffect, useState} from "react";
import {toast} from "react-toastify";


const Form_SB_30 = props => {
    const {matterContacts, selectedMatter, selectedForm, xfaCombinedData, setXfaCombinedData, xfaGeneratedForm, modify} = props;
    const [selectedDate, setSelectedDate] = useState(moment(xfaCombinedData?.find(xfaData => xfaData.form_id === selectedForm && xfaData.matter_id === selectedMatter)?.data?.submission?.appealDate || null));
    const initialState = {
        submission: {
            previouslySubmitted: false,
            appealArguments: false,
            appealDate: null,
            othersPreviouslySubmittedCheck: false,
            othersPreviouslySubmitted: "",

            enclosed: false,
            amendment: false,
            ids: false,
            affidavits: false,
            othersEnclosedCheck: false,
            othersEnclosed: ""
        },
        miscellaneous: {
            suspension: false,
            months: "",
            othersMiscellaneousCheck: false,
            othersMiscellaneous: ""
        },
        fees: {
            depositAccountNoCheck: false,
            depositAccountNo: ""
        },
        signature: {
            signatureType: "patent-practitioner",
        }
    };

    const [state, setState] = useState(initialState);

    const {
        submission: {previouslySubmitted, appealArguments, appealDate, othersPreviouslySubmitted, othersPreviouslySubmittedCheck, enclosed, amendment, ids, affidavits, othersEnclosed, othersEnclosedCheck},
        miscellaneous: {suspension, months, othersMiscellaneous, othersMiscellaneousCheck},
        fees: {depositAccountNo, depositAccountNoCheck},
        signature: {signatureType}
    } = state || initialState;

    useEffect(() => {
        const selectedItem = xfaCombinedData?.find(xfaData => xfaData.form_id === selectedForm && xfaData.matter_id === selectedMatter);

        if (modify) {
            if (selectedItem) {
                if (xfaGeneratedForm?.statusCode === 500) {
                    toast.error("Failed to preview the form");
                } else {
                    selectedItem.data = xfaGeneratedForm;
                    setSelectedDate(moment(xfaGeneratedForm?.submission?.appealDate));
                    setState(xfaGeneratedForm);
                }
            }
        }
    }, []);

    useEffect(() => {
        const selectedItem = xfaCombinedData?.find(xfaData => xfaData.form_id === selectedForm && xfaData.matter_id === selectedMatter);
        if (selectedItem?.data) {
            setState(selectedItem.data);
        } else {
            setState(initialState);
        }
    }, [selectedMatter, selectedForm]);

    useEffect(() => {
        setXfaCombinedData &&
        setXfaCombinedData(previousData => {
            const newData = JSON.parse(JSON.stringify(previousData));

            const item = newData?.find(xfaData => xfaData.form_id === selectedForm && xfaData.matter_id === selectedMatter);

            if (item) {
                if (!item.data) {
                    item.data = {};
                }
                item.data = state;
            }

            return newData;
        });
    }, [state]);

    const useStyles = makeStyles({
        smallRadio: {
            "& svg": {
                width: 20,
                height: 20
            },
            "& svg > circle": {
                width: 12,
                height: 12
            }
        },
        smallCheckbox: {
            "& svg": {
                width: 20,
                height: 20
            }
        },
        table: {
            border: "1px solid black"
        },
        row: {
            "&:nth-of-type(odd)": {
                backgroundColor: "#F5F5F5"
            },
            "&:nth-of-type(even)": {
                backgroundColor: "white"
            }
        }
    });

    const classes = useStyles();

    const handleChange = event => {
        let {name, type, checked, value} = event.target;
        const [mainKey, subKey] = name.split(".");

        if (subKey) {
            if (subKey !== "signatories") {
                setState(prevState => ({
                    ...prevState,
                    [mainKey]: {
                        ...prevState[mainKey],
                        [subKey]: type === "checkbox" ? checked : value
                    }
                }));
            }
        } else {
            setState(prevState => ({
                ...prevState,
                [name]: type === "checkbox" ? checked : value
            }));
        }
    };

    useEffect(() => {
        if (selectedDate !== null) {
            const offset = selectedDate._d.getTimezoneOffset(); // Get timezone offset in minutes
            const localDate = new Date(selectedDate._d.getTime() - offset * 60 * 1000); // Adjust date to local timezone
            const dateString = isNaN(localDate.getTime()) ? "" : localDate.toISOString().split("T")[0]; // Extract YYYY-MM-DD

            setState(prevState => ({
                ...prevState,
                submission: {
                    ...prevState?.submission,
                    appealDate: dateString
                }
            }));
        } else {
            setState(prevState => ({
                ...prevState,
                submission: {
                    ...prevState?.submission,
                    appealDate: null
                }
            }));
        }
    }, [selectedDate]);

    const submissionLabel1 = "Previously submitted. If a final Office action is outstanding, any amendments filed after the final Office action may be considered as a submission even if this box is not checked.";
    const previouslySubmittedLabel = "Consider the arguments in the Appeal Brief or Reply Brief previously filed on";

    const miscellaneousLabel1 = "Suspension of action on the above-identified application is requested under 37 CFR 1.103(c) for a period of months ";
    // (Period of suspension shall not exceed 3 months; Fee under 37 CFR 1.17(1) required)";

    const feeLabel1 = "The RCE fee under 37 CFR 1.17(e) is required by 37 CFR 1.114 when the RCE is filed." + "\n" + "The Director is hereby authorized to charge any underpayment of fees, or credit any overpayments, to Deposit Account No";

    return (
        <div>
            <Box
                sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    backgroundColor: "#D3D3D3",
                    color: "black",
                    padding: 0
                }}
            >
                <Box/>
                <Box>Form SB-30</Box>
            </Box>
            <Box sx={{marginTop: "3%"}}>
                <Paper>
                    <Grid container spacing={3}>
                        <Grid item xs={12} sm={6} md={4} lg={2}>
                            <Typography sx={{marginLeft: "2%"}}>SUBMISSION REQUIRED UNDER 37 CFR 1.114</Typography>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4} lg={10}>
                            <FormControlLabel name="submission.previouslySubmitted" control={<Checkbox className={classes.smallCheckbox} checked={previouslySubmitted} onChange={handleChange}/>} label={submissionLabel1}/>
                            {previouslySubmitted && (
                                <div style={{marginLeft: "3%"}}>
                                    <FormControlLabel name="submission.appealArguments" control={<Checkbox className={classes.smallCheckbox} checked={appealArguments} onChange={handleChange}/>} label={previouslySubmittedLabel}/>
                                    {appealArguments && (
                                        <div style={{marginLeft: "3%"}}>
                                            <LocalizationProvider dateAdapter={AdapterMoment}>
                                                <DatePicker
                                                    label="Select Date"
                                                    value={appealDate}
                                                    onChange={newValue => {
                                                        setSelectedDate(newValue);
                                                    }}
                                                    renderInput={params => <TextField {...params} size="small" error={false}/>}
                                                    inputFormat="YYYY-MM-DD"
                                                    maxDate={moment(new Date())}
                                                />
                                            </LocalizationProvider>
                                        </div>
                                    )}
                                    <br/>
                                    <FormControlLabel name="submission.othersPreviouslySubmittedCheck" control={<Checkbox className={classes.smallCheckbox} checked={othersPreviouslySubmittedCheck} onChange={handleChange}/>} label="Other"/>
                                    {othersPreviouslySubmittedCheck && <TextField name="submission.othersPreviouslySubmitted" value={othersPreviouslySubmitted} size="small" label="" fullWidth={false} onChange={handleChange}></TextField>}
                                </div>
                            )}
                            <FormControlLabel name="submission.enclosed" control={<Checkbox className={classes.smallCheckbox} checked={enclosed} onChange={handleChange}/>} label="Enclosed"/>
                            {enclosed && (
                                <div style={{marginLeft: "3%"}}>
                                    <FormControlLabel name="submission.amendment" control={<Checkbox className={classes.smallCheckbox} checked={amendment} onChange={handleChange}/>} label="Amendment/Reply"/>
                                    <br/>
                                    <FormControlLabel name="submission.ids" control={<Checkbox className={classes.smallCheckbox} checked={ids} onChange={handleChange}/>} label="Information Disclosure Statement (IDS)"/>
                                    <br/>
                                    <FormControlLabel name="submission.affidavits" control={<Checkbox className={classes.smallCheckbox} checked={affidavits} onChange={handleChange}/>} label="Affidavitis/Declaration(s)"/>
                                    <br/>
                                    <FormControlLabel name="submission.othersEnclosedCheck" control={<Checkbox className={classes.smallCheckbox} checked={othersEnclosedCheck} onChange={handleChange}/>} label="Other"/>
                                    {othersEnclosedCheck && <TextField name="submission.othersEnclosed" value={othersEnclosed} size="small" label="" fullWidth={false} onChange={handleChange}></TextField>}
                                </div>
                            )}
                        </Grid>
                    </Grid>
                    <br/>
                </Paper>
            </Box>
            <Box sx={{marginTop: "3%"}}>
                <Paper>
                    <Grid container spacing={3}>
                        <Grid item xs={12} sm={6} md={4} lg={2}>
                            <Typography sx={{marginLeft: "2%"}}>MISCELLANEOUS</Typography>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4} lg={10}>
                            <FormControlLabel name="miscellaneous.suspension" control={<Checkbox className={classes.smallCheckbox} checked={suspension} onChange={handleChange}/>} label={miscellaneousLabel1}/>
                            {suspension && <TextField name="miscellaneous.months" value={months} size="small" label="" fullWidth={false} onChange={handleChange} sx={{width: "5%"}}></TextField>}
                            <br/>
                            <FormControlLabel name="miscellaneous.othersMiscellaneousCheck" control={<Checkbox className={classes.smallCheckbox} checked={othersMiscellaneousCheck} onChange={handleChange}/>} label="Other"/>
                            {othersMiscellaneousCheck && <TextField name="miscellaneous.othersMiscellaneous" value={othersMiscellaneous} size="small" label="" fullWidth={false} onChange={handleChange}></TextField>}
                        </Grid>
                    </Grid>
                    <br/>
                </Paper>
            </Box>
            <Box sx={{marginTop: "3%"}}>
                <Paper>
                    <Grid container spacing={3}>
                        <Grid item xs={12} sm={6} md={4} lg={2}>
                            <Typography sx={{marginLeft: "2%"}}>FEES</Typography>
                        </Grid>

                        <Grid item xs={12} sm={6} md={4} lg={10}>
                            <FormControlLabel name="fees.depositAccountNoCheck" control={<Checkbox className={classes.smallCheckbox} checked={depositAccountNoCheck} onChange={handleChange}/>} label={feeLabel1}/>
                            <br/>
                            {depositAccountNoCheck && <TextField name="fees.depositAccountNo" value={depositAccountNo} size="small" label="Enter Account Number" fullWidth={false} onChange={handleChange} sx={{marginLeft: "3%"}}></TextField>}
                        </Grid>
                    </Grid>
                    <br/>
                </Paper>
            </Box>
            <Box sx={{marginTop: "3%"}}>
                <Paper>
                    <Grid container spacing={3}>
                        <Grid item xs={12} sm={6} md={4} lg={2}>
                            <Typography sx={{marginLeft: "2%"}}>SIGNATURE OF APPLICANT, ATTORNEY, OR AGENT REQUIRED</Typography>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4} lg={5}>
                            <RadioGroup name="signature.signatureType" value={signatureType} onChange={handleChange}>
                                <FormControlLabel value="patent-practitioner" control={<Radio className={classes.smallRadio}/>} label="Patent Practitioner Signature"/>
                                <FormControlLabel value="applicant" control={<Radio className={classes.smallRadio}/>} label="Applicant Signature"/>
                            </RadioGroup>
                        </Grid>
                    </Grid>
                    <Box pt="20%"/>
                </Paper>
            </Box>
        </div>
    );
};


export default Form_SB_30;